/** Topics discussed (checkboxes) — from RetentionTeam.html */
export const RETAIN_IQ_TOPICS = [
  'Pricing / Rates',
  'Hardware Issue',
  'Software / POS',
  'Uptime / Downtime',
  'Chargeback',
  'Billing Dispute',
  'Contract / Terms',
  'Feature Request',
  'Competitor Comparison',
  'Onboarding / Training',
  'Staff Training',
  'Multiple Locations',
  'Renewal Discussion',
  'Cancellation Request',
  'Other',
];

/** Overall call outcome buttons */
export const RETAIN_IQ_OUTCOMES = [
  'Retained / Satisfied',
  'Risk Mitigated',
  'Upsell Closed',
  'Issue Resolved',
  'Follow-up Scheduled',
  'Still At Risk',
  'Churned / Cancelled',
  'Voicemail Left',
  'Escalated',
];

export const CALL_TYPE_OPTIONS: { label: string; options: { label: string; value: string }[] }[] = [
  {
    label: 'Outreach',
    options: [
      { label: '30-Day Onboarding Follow-up', value: '30-Day Onboarding Follow-up' },
      { label: 'Quarterly Check-in', value: 'Quarterly Check-in' },
      { label: 'Annual Business Review', value: 'Annual Business Review' },
      { label: 'Upsell / Cross-sell', value: 'Upsell / Cross-sell' },
      { label: 'NPS / Satisfaction Survey', value: 'NPS / Satisfaction Survey' },
    ],
  },
  {
    label: 'Intervention',
    options: [
      { label: 'High-Risk Intervention', value: 'High-Risk Intervention' },
      { label: 'Complaint Resolution', value: 'Complaint Resolution' },
      { label: 'Save Call', value: 'Save Call' },
      { label: 'Win-Back', value: 'Win-Back' },
    ],
  },
  {
    label: 'Other',
    options: [
      { label: 'Inbound Support Follow-up', value: 'Inbound Support Follow-up' },
      { label: 'Scheduled Follow-up', value: 'Scheduled Follow-up' },
      { label: 'Ad Hoc Outreach', value: 'Ad Hoc Outreach' },
    ],
  },
];

export const CONTACT_METHODS = ['Phone Call', 'Video Call', 'Email', 'SMS', 'In-Person'];

export const ACCOUNT_TIERS = [
  '',
  'Tier 1 — Strategic ($5K+/mo)',
  'Tier 2 — Growth ($2–5K/mo)',
  'Tier 3 — Core ($500–2K/mo)',
  'Tier 4 — Emerging (<$500/mo)',
];

export const ACCOUNT_TENURES = [
  '',
  '0–6 months (New)',
  '6–12 months',
  '1–2 years',
  '2–5 years',
  '5+ years',
];

export const ESCALATION_TYPES = [
  '',
  'Team Lead Review',
  'Technical Support',
  'Billing / Finance',
  'Sales / Account Exec',
  'Executive Escalation',
  'Chargeback Specialist',
];

export const OFFER_OPTIONS = [
  '',
  'Rate Reduction (approved)',
  'Statement Credit',
  'Free Month of Service',
  'Hardware Discount',
  'Contract Extension Incentive',
  'Fee Waiver',
  'Priority Support Assignment',
  'Custom (see notes)',
];

export const UPSELL_PRODUCTS = [
  '',
  'Advanced POS Hardware Upgrade',
  'Online Ordering / E-commerce',
  'Inventory Management Module',
  'Loyalty / Rewards Program',
  'Payroll Integration',
  'Gift Card Program',
  'Multi-location Expansion',
  'Analytics / Reporting Dashboard',
  'Payment Terminal Add-on',
  'Chargeback Protection Plan',
  'Other (see notes)',
];
